import * as React from 'react';
import { Loader } from 'semantic-ui-react';

import { AlphaDetailsSummaryColumns } from '../../shared/data/AlphaDetailsSummaryColumns';
import HOCStageChooser from '../HOCStageChooser/HOCStageChooser';

import { AlphaSummaryProps, AlphaSummaryStateProps } from './types';
import Summary from './Summary/Summary';

const AlphaSummary = (props: AlphaSummaryProps & AlphaSummaryStateProps) => {
  const { alpha, modifiers, path, userId, id, typeStage, isSimulation } = props;

  const tableHeader = AlphaDetailsSummaryColumns[typeStage];

  const alphaRecords = alpha && alpha.getIn([typeStage]);
  const tableInfo = alphaRecords && alphaRecords.toJS();

  if (!tableInfo) {
    return (
      <div className="loader">
        <Loader active={true} inline="centered" size="massive" />
      </div>
    );
  } else {
    return (
      <React.Fragment>
        {alpha && (
          <Summary
            modifiers={modifiers}
            tableHeader={tableHeader}
            tableInfo={tableInfo}
            typeStage={typeStage}
            alfaId={alpha.get('id')}
            path={path}
            userId={userId}
            id={id}
            isSimulation={isSimulation}
          />
        )}
      </React.Fragment>
    );
  }
};

export default HOCStageChooser(AlphaSummary) as any;
